import React from "react";

const UnknownError = () => {
  return (
    <div className="flex flex-col h-[100vh] w-[100vw] bg-white justify-center items-center gap-5">
      <div>There's some error, please relogin</div>
      <a
        href="/login"
        className="px-4 py-2 bg-primary text-white font-sans rounded-lg hover:bg-secondary cursor-pointer"
      >
        Relogin
      </a>
    </div>
  );
};

export default UnknownError;
